<script>
  import { getContext } from 'svelte'

  import Work from '~/components/business/work.svelte'
  import Container from '~/components/ui/container.svelte'

  const page = getContext('portfolio_page')

  const galleryList = page.gallery
</script>

<section class="section | mb-[128px]">
  <div>
    <Container>
      <h2 class="title | mb-8 text-center text-4xl font-medium lg:text-5xl">Portfolio</h2>
    </Container>

    <div class="gallery-wrapper | w-full lg:-mx-2">
      <div class="gallery-list | row row-wrap mx-auto w-full justify-start px-2 lg:w-[80%] lg:px-0">
        {#each galleryList as { slug, title, description, image, customer }}
          <div class="gallery-item | grow lg:w-1/3 lg:flex-grow-0">
            <div class="m-2 grow">
              <Work {slug} {title} {description} {image} {customer} />
            </div>
          </div>
        {/each}
      </div>
    </div>
  </div>
</section>
